<!-- 集体备课分析 -->
<template>
  <div class="collective-lesson">
    <div class="collective-lesson-title">
      <div class="name">集体备课分析</div>
      <!-- <div class="more">详情<i class="el-icon-arrow-right"></i></div> -->
    </div>
    <div class="collective-lesson-number">
      <div class="tips"></div>
      <div class="title">总活动（个）</div>
      <div class="number">{{jtbkNum}}</div>
    </div>
    <div class="collective-lesson-bar">
      <div class="chart" id="collectiveLessonId" ></div>
      <div class="chart-error" v-show="isShow">
          <div class="detail">
              <span class="detail">暂无数据</span>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import {getPlatformSchoolTeamInviteStatAPI} from "@/service/api.js"
export default {
  name: 'collective-lesson',
  components: {
  },
  props:{
    //区域id
    regionId:{
      type:String,
      default:""
    },
    //区域平台类型
    regionType:{
      type:String,
      default:""
    },
    //区域平台名称
    regionName:{
      type:String,
      default:""
    },
    //省id
    provinceId:{
      type:String,
      default:''
    },
    //市id
    cityId:{
      type:String,
      default:''
    },
    //区id
    districtId:{
      type:String,
      default:''
    },
    //乡镇地址
    address:{
      type:String,
      default:''
    },
    //开始时间
    startTime:{
      type:String,
      default:""
    },
    //结束时间
    endTime:{
      type:String,
      default:""
    },
    jtbkNum:{
      type:Number,
      default:0
    },
    //局端集体备课数量
    regionJtbkNum:{
      type:Number,
      default:0
    },
    //局端集体备课参加人数
    regionJtbkJoinNum:{
      type:Number,
      default:0
    }
  },
  watch:{
    startTime(){
      this.getPlatformSchoolTeamInviteStat();
    },
    endTime(){
      this.getPlatformSchoolTeamInviteStat();
    },
    address(){
      this.getPlatformSchoolTeamInviteStat();
    }
  },
  data() {
      return {
        schoolList:[]  
      }
  },
  methods: {
    /**
     * @name 初始化echarts图表
     */
    initEchart(){
      let _this = this;
      let nameList = _this.schoolList.map((item)=>{
        return item.schoolName
      })
      let numberList = _this.schoolList.map((item)=>{
        return item.creatNumber
      })
      let dataSource = _this.$echarts.init(
          document.getElementById('collectiveLessonId')
      );
      const option = {
        xAxis: {
          type: 'category',
          data: nameList,
          axisLabel: {
            color: '#708ACC',
            formatter:function (value) {
              if(value){
                if(value.length > 4){
                  let nameList = [];
                  for (var i = 0; i < value.length; i += 4) {
                    nameList.push(value.substring(i, i + 4));
                  }
                  return nameList.join("\n")
                }else{
                  return value
                }
              }
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#708ACC'
          },
        },
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0, color: '#0181DE' // 0% 处的颜色
          }, {
            offset: 1, color: '#67E0E3' // 100% 处的颜色
          }],
          global: false
        },
        series: [
          {
            data: numberList,
            barWidth:40,
            type: 'bar',
            label: {
              show: true,
              position: 'top',
              formatter: '{c}',
              fontSize:17,
              color:'#0EFCFF'
            }
          }
        ]
      }
      dataSource.setOption(option);
      window.addEventListener("resize", function () {
          dataSource.resize();
      });
    },

    /**
     * @name 获取平台学校集体备课统计
     */
    getPlatformSchoolTeamInviteStat(){
      let params = {
        regionId:this.regionId,
        startTime:this.startTime?`${this.startTime} 00:00:00` :'',
        endTime:this.endTime ? `${this.endTime} 23:59:59` :'',
        keyWord:"",
        page:1,
        limit:5,
        provinceId:this.provinceId,
        cityId:this.cityId,
        districtId:this.districtId,
        address:this.address,
        regionType:this.regionType
      }
      getPlatformSchoolTeamInviteStatAPI(params).then((res)=>{
        this.schoolList = res.rows.map((item)=>{
          return {
            schoolName:item.schoolName,
            schoolId:item.schoolId,
            creatNumber:item.jtbkNum,
            joinNumber:item.jtbkJoinNum
          }
        })
        if(this.regionJtbkNum > 0 && this.regionJtbkNum > this.schoolList[this.schoolList.length - 1].creatNumber){
          this.schoolList.push({
            schoolName:this.regionName,
            schoolId:this.regionId,
            creatNumber:this.regionJtbkNum,
            joinNumber:this.regionJtbkJoinNum
          })
        }
        this.schoolList.sort((a, b) => {
          return b.creatNumber - a.creatNumber;
        })
        if(this.schoolList.length > 5){
          this.schoolList.length = 5
        }
        console.log(this.schoolList);
        //初始化图表
        this.initEchart();
      }).catch((err)=>{})
    },

  },
  mounted() {
    //获取平台学校集体备课统计
    this.getPlatformSchoolTeamInviteStat();
  }
}
</script>
<style lang="scss" scoped>
.collective-lesson{
  padding: 0 5px;
  margin-top: 25px;
  // height: 450px;
  width: 100%;
  background: rgba(9,19,66,0.6);
  border: 1px solid #427CC2;
  border-radius: 0px 0px 4px 4px;
  .collective-lesson-title{
    background: url("~@/assets/images/qxdataboard/head-bg.png") no-repeat ;
    background-size:100% 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    height: 40px;
    .name{
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }
    .more{
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #B9E3F7;
    }
  }
  .collective-lesson-number{
    display: flex;
    align-items: center;
    margin-top:24px;
    margin-left: 18px;
    .tips{
      width: 10px;
      height: 10px;
      background: #FFDF25;
      border-radius: 50%;
      margin-right: 4px;
    }
    .title{
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #C4D6F2;
      margin-right: 15px;
    }
    .number{
      font-size: 32px;
      font-family: MaravaleExpanded;
      font-weight: normal;
      color: #6FEFFF;
      @font-face {
        font-family: MaravaleExpanded;
        src: url('../../../assets/fonts/digifaw.ttf'); //字体路径
      }
    }
  }
  .collective-lesson-bar{
    width: 100%;
    height: 400px;
    .chart{
      width: 100%;
      height: 100%;
    }
  }
}
</style>
<style lang="scss">
.collective-lesson{
  
}
</style>